module.exports = __webpack_public_path__ + "assets/img/0.3b8108d2.png";